import { useState } from 'react';
import { MediaBlock as IMediaBlock } from '@/lib/types';
import BaseInputBlock from './base-input-block';
import FileUploader from './file-uploader';
import { useFillableBlockResponse } from './common';

interface Props {
  block: IMediaBlock;
}

export default function CreateMediaBlock({ block }: Props) {
  const { payload, updatePayload } = useFillableBlockResponse({ block });
  const [files, setFiles] = useState<{ file: string; thumbnail: string }[]>(payload?.value || []);
  const [newFiles, setNewFiles] = useState<File[]>([]);

  const handleUpload = (newFile: File) => {
    const uploadedFile = {
      file: URL.createObjectURL(newFile),
      thumbnail: '',
    };
    const updatedFiles = [...files, uploadedFile];
    setFiles(updatedFiles);
    const tempNewFiles = [...newFiles, newFile];
    setNewFiles(tempNewFiles);
    updatePayload({ value: tempNewFiles });
  };

  const handleDelete = (file: string, index: number) => {
    setFiles((prev) => prev.filter((item) => item.file !== file));
    const tempNewFiles = newFiles.filter((_, i) => i !== index);
    setNewFiles(tempNewFiles);
    updatePayload({ value: tempNewFiles });
  };

  return (
    <BaseInputBlock block={block}>
      <FileUploader files={files} onUpload={handleUpload} onDelete={handleDelete} />
    </BaseInputBlock>
  );
}
